import styled from 'styled-components';

export const FavoritePageWrap = styled.div`
  padding-bottom: 50px;
  background: transparent;
  @media screen and (min-width: 768px) {
    padding-bottom: 100px;
  }
`;
